/**
 * Enum of the application load status.
 */
export enum LoadStatus {
  AuthenticatedViaAuth0 = 'authenticatedViaAuth0',
  AuthenticatedViaSchedulingKey = 'authenticatedViaSchedulingKey',
  AuthTimeout = 'authTimeout',
  ErrorInitialization = 'errorInitialization',
  ErrorLoadingSettings = 'errorLoadingSettings',
  ErrorLoadingDatasets = 'errorLoadingDatasets',
  Loading = 'loading',
  LoadedPublic = 'loadedPublic',
  NoSubscription = 'noSubscription',
  NotAuthorizedForAuth0 = 'notAuthorizedForAuth0',
  NotAuthorizedForScheduler = 'notAuthorizedForScheduler',
  UnverifiedEmail = 'unverifiedEmail'
}
